import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  title?: string
}

export const UmraTag = ({ title }: Props) => {
  return (
    <div className={s.container}>
      <AppIcon
        width={10}
        height={10}
        className={s.icon}
        id={AllIcons.PLAIN_RIGHT}
      />

      <span className={'semi-bold-11'}>{title}</span>
    </div>
  )
}
